module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/images/bg-pattern.774109b4.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/images/bg-pattern.png
// module id = 3082
// module chunks = 11